import { blake2b } from '@noble/hashes/blake2.js';
import { bytesToHex, hexToBytes } from '@noble/hashes/utils.js';
import { encodeAddress } from '@polkadot/util-crypto';

const bittensorSs58Prefix = 42;

const normalizeH160 = (address: string): Uint8Array => {
  const normalized = address.startsWith('0x') ? address.slice(2) : address;

  if (!/^[0-9a-fA-F]{40}$/.test(normalized)) {
    throw new Error('Expected a 20-byte EVM address');
  }

  return hexToBytes(normalized.toLowerCase());
};

const mirrorAccountBytes = (address: string): Uint8Array => {
  const prefix = new TextEncoder().encode('evm:');
  const h160 = normalizeH160(address);
  const payload = new Uint8Array(prefix.length + h160.length);
  payload.set(prefix);
  payload.set(h160, prefix.length);

  return blake2b(payload, { dkLen: 32 });
};

export const evmAddressToMirrorColdkey = (address: string): `0x${string}` =>
  `0x${bytesToHex(mirrorAccountBytes(address))}`;

export const evmAddressToSs58Mirror = (address: string): string => {
  const account = mirrorAccountBytes(address);

  return encodeAddress(account, bittensorSs58Prefix);
};
